/* components/reports/AiSkippedNote.jsx — строка «AI-диагностика не выполнена»
   в отчётах v2 (инвентаризация / FC-оптимизация / ABC).

   Пространство без тарифа: бэкенд сохранил расчётную часть отчёта, а к модели
   за диагнозами/комментариями не ходил (`result.ai_skipped:'subscription_expired'`).
   Без пометки отчёт выглядел «пустым на выводы» без причины. Текст — из
   lib/aiAccess.js (единое сопоставление); без ключа — ничего не рисуем.
   Только разметка, без навигации: отчёты рендерятся и вне провайдеров. */

import React from 'react';
import { Icon } from '../ui/Icon.jsx';
import { reportAiSkippedNote } from '../../lib/aiAccess.js';

function AiSkippedNote({ r }) {
  const note = reportAiSkippedNote(r);
  if (!note) return null;
  return (
    <div className="callout callout--warn inv2-callout" role="note">
      <Icon name="alert-triangle" size={15} />
      <div>{note}</div>
    </div>
  );
}

export { AiSkippedNote };
